export const translations = {
  en: {
    // Header
    nav: {
      about: 'About',
      services: 'Services',
      products: 'Products',
      projects: 'Projects',
      contact: 'Contact',
      getQuote: 'Get a Quote'
    },
    
    // Hero Section
    hero: {
      title: 'Industrial & Cryogenic Gases',
      subtitle: 'Engineering Excellence',
      description: 'Specialized in supply, logistics, and engineering solutions for industrial gases. Backed by 15+ years of experience with world-class standards.',
      requestQuote: 'Request a Quote',
      ourServices: 'Our Services'
    },
    
    // Trust Indicators
    trust: {
      experience: 'Years Experience',
      endToEnd: 'End-to-End Expertise',
      endToEndDesc: 'From engineering and procurement to installation and after-sales support.',
      knowHow: 'Specialized Know-How',
      knowHowDesc: 'Deep expertise in O₂, N₂, Ar, CO₂, He, and LNG systems.',
      quality: 'Quality Guaranteed'
    },
    
    // About Section
    about: {
      title: 'Expert Team',
      description: 'Our team consists of experienced specialists with proven track records in logistics and engineering solutions.',
      igor: {
        name: 'Igor Stojiljković',
        title: 'Traffic Engineer',
        description: '15 years of experience in logistics in domestic and international environments for gas supply.\nBusiness development and solutions provider.'
      },
      branislav: {
        name: 'Branislav Pilipović',
        title: 'Mechanical Engineer',
        description: 'More than 10 years of experience in engineering, construction, and maintenance of industrial and cryogenic gas systems, as well as filling plants, delivering tailored solutions and supporting business development across the gas sector.'
      },
      heritage: {
        title: 'Gained Experience',
        description: 'We gained our experience and knowledge within the SOL Group, one of the world\'s 10 largest suppliers and producers of industrial gases. This background ensures world-class service quality for your business.'
      }
    },
    
    // Services Section
    services: {
      title: 'Our Solutions',
      description: 'Comprehensive services from supply and logistics to advisory and engineering solutions.',
      logistics: {
        title: 'Supply Solutions',
        features: [
          'Stability and continuity of delivery',
          'Optimized logistics for domestic and international supply',
          'Flexible quantities and delivery terms'
        ]
      },
      engineering: {
        title: 'Engineering Services',
        features: [
          'Gas application engineering solutions',
          'Construction and maintenance of filling plants',
          'Technical installations and systems'
        ]
      },
      advisory: {
        title: 'Consulting Services',
        features: [
          'Production optimization consultation',
          'Cost savings analysis and implementation',
          'Industry best practices guidance'
        ]
      }
    },
    
    // Products Section
    products: {
      title: 'Our Products',
      description: 'High-purity industrial and cryogenic gases for demanding applications.',
      argon: {
        title: 'Liquid Argon 5.0',
        subtitle: 'High Purity Grade - Ultra Clean',
        keyFeatures: 'Key Features:',
        applications: 'Applications:',
        features: [
          '99.999% purity (Grade 5.0)',
          'Highest standards of cleanliness',
          'Ideal for bottling plant operations',
          'Suitable for precise and demanding applications'
        ],
        apps: [
          'Laboratory and analytical procedures',
          'Welding and metal fabrication',
          'Electronics manufacturing',
          'Food and beverage preservation'
        ]
      },
      dme: {
        title: 'Dimethyl Ether (DME)',
        subtitle: 'Clean Alternative Fuel & Aerosol Propellant',
        features: [
          'Environmentally friendly, clean-burning fuel',
          'Low toxicity and non-carcinogenic',
          'High cetane number for diesel engines',
          'Excellent aerosol propellant properties'
        ],
        apps: [
          'Alternative diesel fuel and fuel additive',
          'Aerosol propellant for personal care products',
          'Refrigerant and chemical synthesis',
          'LPG blending and cooking fuel'
        ]
      },
      helium: {
        title: 'Helium 5.0',
        subtitle: 'Ultra High Purity Grade - Research Quality',
        features: [
          '99.999% purity (Grade 5.0)',
          'Inert, non-flammable, and non-toxic',
          'Extremely low boiling point (-268.9°C)',
          'Superior thermal and electrical properties'
        ],
        apps: [
          'MRI and NMR cooling systems',
          'Semiconductor and fiber optic manufacturing',
          'Leak detection and gas chromatography',
          'Welding shielding gas and diving mixtures'
        ]
      },
      nitrogen: {
        title: 'Liquid Nitrogen',
        subtitle: 'Cryogenic Grade - Industrial & Laboratory Use',
        features: [
          'Boiling point at -196°C (-320°F)',
          'Inert and non-reactive properties',
          'Extremely low temperature coolant',
          'Cost-effective cryogenic solution'
        ],
        apps: [
          'Food freezing and preservation',
          'Metal treatment and cryogenic processing',
          'Medical and pharmaceutical applications',
          'Laboratory research and cooling systems'
        ]
      },
      oxygen: {
        title: 'Liquid Oxygen',
        subtitle: 'Medical & Industrial Grade',
        features: [
          'High purity medical and industrial grades',
          'Boiling point at -183°C (-297°F)',
          'Essential for combustion processes',
          'Oxidizing agent for various applications'
        ],
        apps: [
          'Medical oxygen therapy and hospitals',
          'Metal cutting and welding operations',
          'Wastewater treatment and aquaculture',
          'Rocket propulsion and aerospace'
        ]
      },
      refrigerants: {
        title: 'Refrigerant Gases',
        subtitle: 'R-134a, R-410A, R-32, R-22, R-744 (CO₂)',
        features: [
          'Wide range of refrigerant types',
          'Suitable for various HVAC systems',
          'Environmentally compliant options',
          'High efficiency cooling properties'
        ],
        apps: [
          'Air conditioning systems (residential & commercial)',
          'Refrigeration equipment and cold storage',
          'Heat pump applications',
          'Automotive air conditioning'
        ]
      },
      carbide: {
        title: 'Calcium Carbide (CaC₂)',
        subtitle: 'Chemical Compound - Industrial Grade',
        features: [
          'Grayish-black crystalline compound',
          'High purity industrial grade',
          'Acetylene gas production source',
          'Stable storage and handling properties'
        ],
        apps: [
          'Acetylene gas production for welding',
          'Industrial calcium hydroxide manufacturing',
          'Steel manufacturing and desulfurization',
          'Chemical synthesis applications'
        ]
      },
      sieves: {
        title: 'Molecular Sieves',
        subtitle: 'For Oxygen & Nitrogen Generation',
        features: [
          'High adsorption capacity',
          'Selective gas separation technology',
          'Long operational lifespan',
          'Regenerable and reusable'
        ],
        apps: [
          'On-site oxygen generation systems',
          'On-site nitrogen generation systems',
          'PSA (Pressure Swing Adsorption) units',
          'Industrial gas purification'
        ]
      },
      moreInfo: 'Need information about other industrial gases?',
      contactButton: 'Contact Us for More Products'
    },
    
    // FAQ Section
    faq: {
      title: 'Frequently Asked Questions',
      description: 'Learn more about our services and capabilities',
      q1: {
        question: 'What makes NOBLE Gases & Solutions different?',
        answer: 'Our team brings 15+ years of combined experience from working with the SOL Group, one of the world\'s top 10 industrial gas suppliers. We offer world-class service quality with the flexibility and personal attention of a dedicated specialist team.'
      },
      q2: {
        question: 'What areas do you serve?',
        answer: 'We provide services in both domestic and international markets, with expertise in cross-border logistics and supply chain management for industrial gases.'
      },
      q3: {
        question: 'Can you handle custom engineering projects?',
        answer: 'Yes! Our mechanical engineering expertise includes design, construction, and maintenance of technical gas filling plants and installations. We can develop custom solutions tailored to your specific requirements.'
      },
      q4: {
        question: 'What is the minimum order quantity?',
        answer: 'We offer flexibility in quantities and delivery terms according to your needs. Contact us to discuss your specific requirements and we\'ll create a solution that works for your business.'
      }
    },
    
    // Projects Section
    projects: {
      title: 'Reference Projects',
      description: 'Explore our successfully completed installations and engineering solutions',
      noProjects: 'No projects available at the moment.',
      interested: 'Interested in starting your own project?',
      contactUs: 'Contact Us'
    },
    
    // Contact Section
    contact: {
      title: 'Get in Touch',
      description: 'Ready to discuss your industrial gas needs? Contact us today for a quote.',
      info: 'Contact Information',
      email: 'Email Addresses',
      phone: 'Phone Numbers',
      sendMessage: 'Send us a Message',
      form: {
        name: 'Name',
        email: 'Email',
        phone: 'Phone',
        company: 'Company',
        message: 'Message',
        namePlaceholder: 'Your full name',
        emailPlaceholder: 'your.email@company.com',
        phonePlaceholder: '+381 XX XXX XXXX',
        companyPlaceholder: 'Your company name',
        messagePlaceholder: 'Tell us about your requirements...',
        sending: 'Sending...',
        send: 'Send Message',
        success: 'Message Sent!',
        successDesc: 'Thank you for contacting us. We\'ll get back to you soon.',
        error: 'Error',
        errorDesc: 'Something went wrong. Please try again.'
      }
    },
    
    // Footer
    footer: {
      description: 'Specialized in supply, logistics, and engineering solutions for industrial and cryogenic gases.',
      quickLinks: 'Quick Links',
      contactUs: 'Contact Us',
      rights: 'NOBLE Gases & Solutions. All rights reserved.'
    },
    
    // Admin
    admin: {
      title: 'Reference Projects Admin',
      description: 'Manage your portfolio of completed projects',
      backToWebsite: 'Back to Website',
      addProject: 'Add New Project',
      editProject: 'Edit Project',
      fillDetails: 'Fill in the project details below',
      projectTitle: 'Project Title',
      location: 'Location',
      year: 'Year',
      imageUrl: 'Image URL',
      description: 'Description',
      tags: 'Tags (comma-separated)',
      tagsHelp: 'Separate tags with commas',
      update: 'Update Project',
      add: 'Add Project',
      cancel: 'Cancel',
      edit: 'Edit',
      delete: 'Delete',
      deleteConfirm: 'Are you sure you want to delete this project?',
      noProjects: 'No projects yet. Add your first project to get started!',
      successAdd: 'Project added successfully.',
      successUpdate: 'Project updated successfully.',
      successDelete: 'Project deleted successfully.',
      errorSave: 'Failed to save project.',
      errorDelete: 'Failed to delete project.'
    }
  },
  
  sr: {
    // Header - Хедер
    nav: {
      about: 'О нама',
      services: 'Услуге',
      products: 'Производи',
      projects: 'Пројекти',
      contact: 'Контакт',
      getQuote: 'Затражите понуду'
    },
    
    // Hero Section - Хероска секција
    hero: {
      title: 'Индустријски и криогени гасови',
      subtitle: 'Инжењерска изврсност',
      description: 'Специјализовани за снабдевање, логистичка и инжењерска решења за индустријске гасове. Подржано са 15+ година искуства и светским стандардима.',
      requestQuote: 'Затражите понуду',
      ourServices: 'Наше услуге'
    },
    
    // Trust Indicators - Индикатори поверења
    trust: {
      experience: 'Године искуства',
      endToEnd: 'Комплетна стручност',
      endToEndDesc: 'Од инжењеринга и набавке до инсталације и постпродајне подршке.',
      knowHow: 'Специјализовано знање',
      knowHowDesc: 'Дубока стручност у системима за O₂, N₂, Ar, CO₂, He и ТПГ.',
      quality: 'Гарантован квалитет'
    },
    
    // About Section - О нама
    about: {
      title: 'Стручни тим',
      description: 'Наш тим се састоји од искусних стручњака са доказаним резултатима у логистици и инжењерским решењима.',
      igor: {
        name: 'Игор Стојиљковић',
        title: 'Саобраћајни инжењер',
        description: '15 година искуства у логистици у домаћем и међународном окружењу за снабдевање гасом.\nРазвој пословања и провајдер решења.'
      },
      branislav: {
        name: 'Бранислав Пилиповић',
        title: 'Машински инжењер',
        description: 'Више од 10 година искуства у инжењерингу, изградњи и одржавању индустријских и криогених гасних система, као и постројења за пуњење, пружајући прилагођена решења и подржавајући развој пословања у гасном сектору.'
      },
      heritage: {
        title: 'Стечено искуство',
        description: 'Стекли смо наше искуство и знање у оквиру SOL групе, једног од 10 највећих светских добављача и произвођача индустријских гасова. Ова позадина обезбеђује квалитет услуга светске класе за ваше пословање.'
      }
    },
    
    // Services Section - Услуге
    services: {
      title: 'Наша решења',
      description: 'Свеобухватне услуге од снабдевања и логистике до саветодавних и инжењерских решења.',
      logistics: {
        title: 'Решења снабдевања',
        features: [
          'Стабилност и континуитет испоруке',
          'Оптимизована логистика за домаће и међународно снабдевање',
          'Флексибилне количине и услови испоруке'
        ]
      },
      engineering: {
        title: 'Инжењерске услуге',
        features: [
          'Инжењерска решења за примену гаса',
          'Изградња и одржавање постројења за пуњење',
          'Техничке инсталације и системи'
        ]
      },
      advisory: {
        title: 'Консултантске услуге',
        features: [
          'Консултације за оптимизацију производње',
          'Анализа и имплементација уштеде трошкова',
          'Смернице најбољих пракси у индустрији'
        ]
      }
    },
    
    // Products Section - Производи
    products: {
      title: 'Наши производи',
      description: 'Индустријски и криогени гасови високе чистоће за захтевне примене.',
      argon: {
        title: 'Течни аргон 5.0',
        subtitle: 'Висока чистоћа - Ултра чист',
        keyFeatures: 'Кључне карактеристике:',
        applications: 'Примене:',
        features: [
          '99.999% чистоћа (Ниво 5.0)',
          'Највиши стандарди чистоће',
          'Идеално за погоне за пуњење боца',
          'Погодно за прецизне и захтевне примене'
        ],
        apps: [
          'Лабораторијске и аналитичке процедуре',
          'Заваривање и обрада метала',
          'Производња електронике',
          'Конзервисање хране и пића'
        ]
      },
      dme: {
        title: 'Диметил етар (DME)',
        subtitle: 'Чисто алтернативно гориво и аеросолски погонски гас',
        features: [
          'Еколошки прихватљиво, чисто сагоревајуће гориво',
          'Ниска токсичност и није канцероген',
          'Висок цетански број за дизел моторе',
          'Одличне особине аеросолског погонског гаса'
        ],
        apps: [
          'Алтернативно дизел гориво и адитив',
          'Аеросолски погонски гас за производе личне неге',
          'Расхладно средство и хемијска синтеза',
          'Мешање са ТНГ-ом и гориво за кување'
        ]
      },
      helium: {
        title: 'Хелијум 5.0',
        subtitle: 'Ултра висока чистоћа - Истраживачки квалитет',
        features: [
          '99.999% чистоћа (Ниво 5.0)',
          'Инертан, незапаљив и нетоксичан',
          'Екстремно ниска тачка кључања (-268.9°C)',
          'Супериорна термичка и електрична својства'
        ],
        apps: [
          'MRI и NMR системи хлађења',
          'Производња полупроводника и оптичких влакана',
          'Детекција цурења и гасна хроматографија',
          'Заштитни гас за заваривање и ронилачке мешавине'
        ]
      },
      nitrogen: {
        title: 'Течни азот',
        subtitle: 'Криогени квалитет - Индустријска и лабораторијска употреба',
        features: [
          'Тачка кључања на -196°C (-320°F)',
          'Инертна и нереактивна својства',
          'Екстремно ниско температурно расхладно средство',
          'Исплативо криогено решење'
        ],
        apps: [
          'Замрзавање и конзервисање хране',
          'Третман метала и криогена обрада',
          'Медицинске и фармацеутске примене',
          'Лабораторијска истраживања и системи хлађења'
        ]
      },
      oxygen: {
        title: 'Течни кисеоник',
        subtitle: 'Медицински и индустријски квалитет',
        features: [
          'Висока чистоћа медицинског и индустријског квалитета',
          'Тачка кључања на -183°C (-297°F)',
          'Неопходан за процесе сагоревања',
          'Оксидационо средство за различите примене'
        ],
        apps: [
          'Медицинска кисеоничка терапија и болнице',
          'Сечење и заваривање метала',
          'Третман отпадних вода и аквакултура',
          'Ракетни погон и ваздухопловство'
        ]
      },
      refrigerants: {
        title: 'Расхладни гасови',
        subtitle: 'R-134a, R-410A, R-32, R-22, R-744 (CO₂)',
        features: [
          'Широк спектар типова расхладних средстава',
          'Погодни за различите HVAC системе',
          'Еколошки усаглашене опције',
          'Високоефикасна својства хлађења'
        ],
        apps: [
          'Системи климатизације (стамбени и комерцијални)',
          'Расхладна опрема и хладњаче',
          'Примене топлотних пумпи',
          'Аутомобилска климатизација'
        ]
      },
      carbide: {
        title: 'Калцијум карбид (CaC₂)',
        subtitle: 'Хемијско једињење - Индустријски квалитет',
        features: [
          'Сивкасто-црно кристално једињење',
          'Висока чистоћа индустријског квалитета',
          'Извор за производњу ацетиленског гаса',
          'Стабилна својства складиштења и руковања'
        ],
        apps: [
          'Производња ацетиленског гаса за заваривање',
          'Производња индустријског калцијум хидроксида',
          'Производња челика и десулфуризација',
          'Примене хемијске синтезе'
        ]
      },
      sieves: {
        title: 'Молекуларна сита',
        subtitle: 'За генерисање кисеоника и азота',
        features: [
          'Висок капацитет адсорпције',
          'Технologija селективне сепарације гаса',
          'Дуг оперативни животни век',
          'Регенеративна и вишекратна употреба'
        ],
        apps: [
          'Системи за генерисање кисеоника на лицу места',
          'Системи за генерисање азота на лицу места',
          'PSA (Pressure Swing Adsorption) јединице',
          'Индустријско пречишћавање гаса'
        ]
      },
      moreInfo: 'Потребне информације о другим индустријским гасовима?',
      contactButton: 'Контактирајте нас за више производа'
    },
    
    // FAQ Section - Често постављана питања
    faq: {
      title: 'Често постављана питања',
      description: 'Сазнајте више о нашим услугама и могућностима',
      q1: {
        question: 'Шта издваја NOBLE Gases & Solutions?',
        answer: 'Наш тим има 15+ година комбинованог искуства из рада са SOL групом, једним од 10 највећих светских добављача индустријских гасова. Нудимо квалитет услуга светске класе са флексибилношћу и личном пажњом посвећеног тима стручњака.'
      },
      q2: {
        question: 'Које области покривате?',
        answer: 'Пружамо услуге на домаћем и међународном тржишту, са стручношћу у прекограничној логистици и управљању ланцем снабдевања за индустријске гасове.'
      },
      q3: {
        question: 'Можете ли да реализујете прилагођене инжењерске пројекте?',
        answer: 'Да! Наша машинска инжењерска стручност укључује пројектовање, изградњу и одржавање постројења и инсталација за пуњење техничких гасова. Можемо развити прилагођена решења према вашим специфичним захтевима.'
      },
      q4: {
        question: 'Која је минимална количина наруџбе?',
        answer: 'Нудимо флексибилност у количинама и условима испоруке према вашим потребама. Контактирајте нас да разговарамо о вашим специфичним захтевима и креираћемо решење које одговара вашем пословању.'
      }
    },
    
    // Projects Section - Референтни пројекти
    projects: {
      title: 'Референтни пројекти',
      description: 'Истражите наше успешно завршене инсталације и инжењерска решења',
      noProjects: 'Тренутно нема доступних пројеката.',
      interested: 'Заинтересовани сте за покретање свог пројекта?',
      contactUs: 'Контактирајте нас'
    },
    
    // Contact Section - Контакт
    contact: {
      title: 'Ступите у контакт',
      description: 'Спремни сте да разговарате о вашим потребама за индустријским гасовима? Контактирајте нас данас за понуду.',
      info: 'Контакт информације',
      email: 'Е-маил адресе',
      phone: 'Бројеви телефона',
      sendMessage: 'Пошаљите нам поруку',
      form: {
        name: 'Име',
        email: 'Е-маил',
        phone: 'Телефон',
        company: 'Компанија',
        message: 'Порука',
        namePlaceholder: 'Ваше пуно име',
        emailPlaceholder: 'vas.email@kompanija.com',
        phonePlaceholder: '+381 XX XXX XXXX',
        companyPlaceholder: 'Назив ваше компаније',
        messagePlaceholder: 'Реците нам о вашим захтевима...',
        sending: 'Шаље се...',
        send: 'Пошаљи поруку',
        success: 'Порука послата!',
        successDesc: 'Хвала што сте нас контактирали. Јавићемо вам се ускоро.',
        error: 'Грешка',
        errorDesc: 'Нешто није у реду. Молимо покушајте поново.'
      }
    },
    
    // Footer - Подножје
    footer: {
      description: 'Специјализовани за снабдевање, логистичка и инжењерска решења за индустријске и криогене гасове.',
      quickLinks: 'Брзи линкови',
      contactUs: 'Контактирајте нас',
      rights: 'NOBLE Gases & Solutions. Сва права задржана.'
    },
    
    // Admin - Администрација
    admin: {
      title: 'Администрација референтних пројеката',
      description: 'Управљајте вашим портфолијом завршених пројеката',
      backToWebsite: 'Назад на веб сајт',
      addProject: 'Додај нови пројекат',
      editProject: 'Измени пројекат',
      fillDetails: 'Попуните детаље пројекта испод',
      projectTitle: 'Назив пројекта',
      location: 'Локација',
      year: 'Година',
      imageUrl: 'URL слике',
      description: 'Опис',
      tags: 'Ознаке (одвојене зарезом)',
      tagsHelp: 'Одвојите ознаке зарезима',
      update: 'Ажурирај пројекат',
      add: 'Додај пројекат',
      cancel: 'Откажи',
      edit: 'Измени',
      delete: 'Обриши',
      deleteConfirm: 'Да ли сте сигурни да желите да обришете овај пројекат?',
      noProjects: 'Још нема пројеката. Додајте свој први пројекат да почнете!',
      successAdd: 'Пројекат успешно додат.',
      successUpdate: 'Пројекат успешно ажуриран.',
      successDelete: 'Пројекат успешно обрисан.',
      errorSave: 'Чување пројекта није успело.',
      errorDelete: 'Брисање пројекта није успело.'
    }
  }
};

export const t = (language, key) => {
  const keys = key.split('.');
  let value = translations[language];
  
  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k];
    } else {
      return key;
    }
  }
  
  return value || key;
};